import { DEPLOYMENT_KEYS } from 'utils/constants'
import { clampStudyDay } from '../constants'
import { getChainDeployVisitIds } from './visitChainStudyDay'

export const getInstrumentChainTriggerIds = schedule => {
  const chainDeployment = schedule?.chain_deployment_info
  if (!chainDeployment || DEPLOYMENT_KEYS.chainDeployByVisit in chainDeployment) return []

  const triggerIds = chainDeployment.prev_instrument_id
  if (Array.isArray(triggerIds)) {
    return triggerIds.filter(id => id != null && id !== '')
  }
  return triggerIds != null && triggerIds !== '' ? [triggerIds] : []
}

/**
 * OR chains use min trigger day; AND chains use max trigger day.
 */
export const getInstrumentChainedStudyDay = (schedule, parentStudyDays = new Map()) => {
  const triggerIds = getInstrumentChainTriggerIds(schedule)
  if (!triggerIds.length) return null

  const triggerDays = triggerIds.map(id => parentStudyDays.get(String(id)))
  if (triggerDays.some(day => day == null || !Number.isFinite(Number(day)))) return null

  const normalizedDays = triggerDays.map(Number)
  const operator = schedule?.chain_deployment_info?.deployment_condition?.operator
  const triggerDay = operator === 'OR' ? Math.min(...normalizedDays) : Math.max(...normalizedDays)
  const offsetValue = Number(schedule?.deploy?.chain_deploy_offset)
  const offset = Number.isFinite(offsetValue) ? offsetValue : 0
  const projectedDay = triggerDay + offset
  return clampStudyDay(projectedDay) ?? projectedDay
}

export const isVisitChainedSchedule = schedule => {
  const chainDeployment = schedule?.chain_deployment_info
  return (
    !!chainDeployment &&
    (DEPLOYMENT_KEYS.chainDeployByVisit in chainDeployment || getChainDeployVisitIds(chainDeployment).length > 0)
  )
}
